// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"216":"forbidden","535":"login","685":"register","790":"forms"}[chunkId] || chunkId) + "." + {"109":"6e02272e","208":"2e8869a7","216":"9b764ee9","535":"d37e9d99","591":"ff169dd6","596":"9993f585","685":"00c7bb17","790":"64ddda6d"}[chunkId] + ".css";
};